import { AppBar, Badge, Toolbar, Button } from "@mui/material";
import Search from "./Search";
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from "../../assets/logo.jpeg";

const Header = () => {

    const navigate = useNavigate();

    // ✅ correct redux access
    const cartItems = useSelector(state => state.cart.items);

    return (
        <AppBar style={{ width: "100%", boxShadow: "none" }}>
            <Toolbar style={{ backgroundColor: "white", height: "70px", display: "flex", justifyContent: "space-between" }}>

                <div className="main-right-container">
                    <img
                        src={logo}
                        alt="logo"
                        onClick={() => navigate("/")}
                        style={{
                            cursor: "pointer",
                            width: "70px",
                            objectFit: "contain"
                        }}
                    />

                    <Search />
                </div>

                <div className="icons-container">

                    <Button
                        onClick={() => navigate("/orders")}
                        variant="text"
                        startIcon={<LocalShippingOutlinedIcon />}
                    >
                        Orders
                    </Button>

                    <Button
                        onClick={() => navigate("/cart")}
                        variant="text"
                        startIcon={
                            <Badge badgeContent={cartItems.length} color="primary">
                                <ShoppingCartOutlinedIcon />
                            </Badge>
                        }
                    >
                        Cart
                    </Button>

                    <Button
                        variant="text"
                        startIcon={<StorefrontOutlinedIcon />}
                    >
                        Seller
                    </Button>

                </div>

            </Toolbar>
        </AppBar>
    );
};

export default Header;